import { DiscussionStoriesMeta, DiscussionStoriesPayload } from 'types/store/DiscussionStories';
import { createAsyncReducer } from 'utils/Redux';

import { discussionStoriesActions } from '../actions';

export default createAsyncReducer<DiscussionStoriesMeta, DiscussionStoriesPayload>(discussionStoriesActions);
